import { render, staticRenderFns } from "./PageBatchOrderDetail.vue?vue&type=template&id=5092c154&scoped=true"
import script from "./PageBatchOrderDetail.vue?vue&type=script&lang=js"
export * from "./PageBatchOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./PageBatchOrderDetail.vue?vue&type=style&index=0&id=5092c154&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5092c154",
  null
  
)

export default component.exports